function Speech(setting = {}) {
    this.speak = word => {
        var msg = new SpeechSynthesisUtterance(word);
        msg.lang = 'zh-TW';
        msg.rate = setting.rate || 1; // 0.1 to 10
        msg.pitch = setting.pitch || 1; //0 to 2
        msg.volume = setting.volume || 1; // default = 1
        msg.onstart = setting.onstart;
        msg.onend = setting.onend;
        msg.onerror = setting.onerror;
        msg.onboundary = setting.onboundary;
        msg.onmark = setting.onmark;
        msg.onpause = setting.onpause;
        msg.onresume = setting.onresume;
        window.speechSynthesis.speak(msg);
    };
    this.cancel = () => {
        if (typeof setting.oncancel === "function" && setting.oncancel !== undefined) {
            setting.oncancel();
        }
        this.cancel_all();
    };
    this.cancel_all = () => {
        window.speechSynthesis.cancel();
    };
    this.pause_all = () => {
        window.speechSynthesis.pause();
    };
    this.resume_all = () => {
        window.speechSynthesis.resume();
    };
}

module.exports = Speech;
